export default "__VITE_ASSET__D46pExM4__"